import { h, Fragment } from 'preact';

import Header from '../../../components/header';
import Footer from '../../../components/footer';

import ArticleTexts from '../../../constants/articles';
import { useEffect } from 'preact/hooks';
import { AutoRefresh, RefreshSession } from '../../../components/socket';
import { GlobalState } from '../../../states/global-state';

const Article = props => {
  const article = ArticleTexts.articles.find(item => item.id == props.id);
  useEffect(() => {
    const refreshSession = AutoRefresh(
      GlobalState.currentPage.value.url == location.pathname,
      v => ''
    );
    return refreshSession;
  }, []);
  return (
    <Fragment>
      <Header />
      <div class="container">
        <ArticleItem {...article} />
      </div>
      <div style={{ height: '15vh' }} />
      <Footer />
    </Fragment>
  );
};

interface ArticleProps {
  title: string;
  author: string;
  date: string;
  slug: string;
  logo: string;
}

const ArticleItem = (article: ArticleProps) => {
  return (
    <div class="my-5">
      <h2 class="text-center">{article.title}</h2>
      <br />
      <p class="text-center">{`${article.date} by ${article.author}`}</p>

      <div class="text-center my-5">
        <img
          src={article.logo}
          alt="article logo"
          style={{ maxWidth: '300px' }}
        />
      </div>

      <div dangerouslySetInnerHTML={{ __html: article.slug }} />
    </div>
  );
};

export default Article;
